"use client";

import React from "react";
import Button from "@/components/primitives/button";
import { scrollToSection } from "@/utils";

interface TableOfContentsItem {
  id: string;
  label: string;
}

interface TableOfContentsProps {
  items: TableOfContentsItem[];
  headerOffset?: number;
}

export default function TableOfContents({
  items,
  headerOffset = 80,
}: TableOfContentsProps) {
  const handleScrollToSection = (id: string) => {
    scrollToSection(id, headerOffset);
  };

  return (
    <ul className="flex flex-col gap-4 pt-4">
      {items.map((item) => (
        <li key={item.id}>
          <Button
            variant="underline"
            className="!text-dark"
            onClick={() => handleScrollToSection(item.id)}
          >
            {item.label}
          </Button>
        </li>
      ))}
    </ul>
  );
}
